import React from 'react';

export const VerticalDivider = ({ className }: { className: string }) => (
  <svg className={className} width="1" height="48" viewBox="0 0 1 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="0.5" y1="2.18557e-08" x2="0.499997" y2="64" stroke="#E5E5E5" />
  </svg>
);
